<h5 mat-dialog-title i18n>Lost Quote Report</h5>
<div mat-dialog-content>
  <p i18n>Please define the filters below</p>
</div>
<form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">
  <div class="form-group row">
    <div class="col-sm-6">
      <div class="control-wrapper">
        <label for="salespersonId" class="col-sm-3 col-form-label" i18n>Salesperson</label>
        <select name="salespersonId" id="salespersonId"
                [(ngModel)]="data.lostQuote.salespersonId" #salespersonId="ngModel"
                class="form-control select-bidit">
          <option value="null" i18n>All</option>
          <option *ngFor="let salesperson of data.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="jobType_ID" class="col-sm-3 col-form-label" i18n>Job Type</label>
        <select name="jobType_ID" id="jobType_ID"
                [(ngModel)]="data.lostQuote.jobType_ID" #jobType_ID="ngModel"
                class="form-control select-bidit">
          <option value="null" i18n>All</option>
          <option *ngFor="let jobType of data.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="customer_ID" class="col-sm-3 col-form-label" i18n>Customer</label>
        <select name="customer_ID" id="customer_ID"
                [(ngModel)]="data.lostQuote.customer_ID" #customer_ID="ngModel"
                class="form-control select-bidit">
          <option value="null" i18n>All</option>
          <option *ngFor="let customer of data.customers" [ngValue]="customer.customer_ID">{{customer.customer_BusinessName}}</option>
        </select>
      </div>
    </div>
    <div class="col-sm-6">
      <p i18n>Define Time Frame</p>
      <div class="control-wrapper">
        <label for="year" class="col-sm-3 col-form-label" i18n>Year</label>
        <select name="year" id="year"
                [(ngModel)]="data.lostQuote.year" #year="ngModel"
                class="form-control select-bidit">
          <option *ngFor="let year of data.years" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="startMonth" class="col-sm-3 col-form-label" i18n>Start Month</label>
        <select name="startMonth" id="startMonth"
                [(ngModel)]="data.lostQuote.startMonth" #startMonth="ngModel"
                class="form-control select-bidit">
          <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="endMonth" class="col-sm-3 col-form-label" i18n>End Month</label>
        <select name="endMonth" id="endMonth"
                [(ngModel)]="data.lostQuote.endMonth" #endMonth="ngModel"
                class="form-control select-bidit">
          <option *ngFor="let month of data.months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
        </select>
      </div>
    </div>

  </div>
  <div class="form-group">
    <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
    <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
  </div>
</form>

